import { MantineColorSchemeManager, MantineColorScheme } from '@mantine/core';

export function createColorSchemeManager(key: string): MantineColorSchemeManager {
    return {
        get: (defaultValue) => {
            if (typeof window === 'undefined') return defaultValue;
            const stored = localStorage.getItem(key);
            return (stored as MantineColorScheme) || defaultValue;
        },

        set: (value) => {
            localStorage.setItem(key, value);
        },

        subscribe: (onColorSchemeChange) => {
            const handler = (event: StorageEvent) => {
                if (event.storageArea === localStorage && event.key === key) {
                    onColorSchemeChange(event.newValue as MantineColorScheme);
                }
            };

            window.addEventListener('storage', handler);
            return () => window.removeEventListener('storage', handler);
        },

        clear: () => {
            localStorage.removeItem(key);
        },

        unsubscribe: () => {
            // No-op or cleanup if subscription was global
        },
    };
}
